import JsonApi from 'devour-client'
import moment from 'moment'
import cookieService from 'vue-cookies'
import baseDomain from '@/api/base-domain'
import store from '@state/store'
import { registerModels } from '@/utils/api-helpers'
import { cartModels } from '@/models/cart-models'
import { customerModels } from '@/models/customer-models'
import { locationModels } from '@/models/location-models'
import { orderModels } from '@/models/order-models'
import { shopModels } from '@/models/shop-models'
import { siteModels } from '@/models/site-models'

function getSavedState(key) {
  const storage = cookieService.get(key)
  if (storage != null) {
    if (Object.prototype.hasOwnProperty.call(storage, 'expiry')) {
      const diff = moment(storage.expiry).diff(moment(), 'days')
      if (diff < 7) return JSON.parse(storage.payload) // if less than a week old, return cart id
      cookieService.remove(key)
    }
  }
  return null
}

const apiVersion = 'v2'

const baseURL = `${baseDomain}/${apiVersion}`
const token = getSavedState('socC3')

const errorMiddleware = {
  name: 'errors',
  error: function(payload) {
    const msg = 'Request failed with status code 401'
    // Clone the error response
    if (JSON.parse(JSON.stringify(payload)).message === msg) {
      store.dispatch('auth/createSession', {
        apiKey: 'bd8b54948f71b1416d0e5b261edbed36',
      })
    } else {
      return payload
    }
  },
}

const jsonApi = new JsonApi({ apiUrl: baseURL })
jsonApi.headers.Authorization = `Bearer ${token}`

jsonApi.replaceMiddleware('errors', errorMiddleware)

registerModels(jsonApi, siteModels)
registerModels(jsonApi, customerModels)
registerModels(jsonApi, locationModels)
registerModels(jsonApi, shopModels)
registerModels(jsonApi, cartModels)
registerModels(jsonApi, orderModels)

export default jsonApi
